module.exports = __webpack_public_path__ + "img/1-m.97578cf7.jpg";